import { render } from "./FieldOptionPrice.vue?vue&type=template&id=59424841"
import script from "./FieldOptionPrice.vue?vue&type=script&lang=js"
export * from "./FieldOptionPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__